import { TypedOptions } from "typed.js";
import { useTypedText } from "../../hooks/use-typed-text.hook";

interface ITypingTextProps {
  options: TypedOptions;
}

export function TypingText({ options }: ITypingTextProps) {
  const { getNode } = useTypedText(options); 

  return <>
    <b ref={getNode}></b>
  </>
}